import Header from 'components/Headers/Header';
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Container, Row } from 'reactstrap';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { handleSendGeneric } from 'services/generic';
import { convertBrl } from 'utility/generic';
import { SelectWihoutControl } from 'components/Form/Fields';
import { TYPE_FILTER } from 'utility/data-offiline';
import CardStatics from 'components/Card/Card';
import { convertToFloatBr } from 'utility/generic';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import _ from 'lodash';

export function TableGeneric({
  columns,
  data,
  reportFilter,
  setReportFilter,
  reportData,
  setReportData,
  rawData,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter
  );

  const { globalFilter } = state;
  const history = useHistory();

  const handleChangeDataReport = (e) => {
    const select = e.target.value;
    setReportFilter(select);

    if (select === 'Todos') {
      return setReportData(rawData);
    }

    if (select === 'Pagamentos') {
      setTimeout(() => history.push('/admin/report/payment'), 200);
      return;
    }

    if (select === 'Pre Venda') {
      setReportData(
        rawData.filter((data) => {
          const { client } = data;
          return client.stocks.some((stock) => parseFloat(stock.quantity) > 0);
        })
      );
    }

    if (select === 'Devedores') {
      setReportData(
        rawData.filter((data) => {
          const { client } = data;
          return (
            client.stocks.every((stock) => parseFloat(stock.quantity) === 0) &&
            parseFloat(data.total_debtor) > 0
          );
        })
      );
    }
  };

  return (
    <>
      <div style={{ marginTop: '12px' }}>
        <CardStatics name={'Saldo Total'}>
          {convertBrl(
            reportData.reduce(
              (a, b) =>
                convertToFloatBr(a) +
                convertToFloatBr(
                  b?.total_debtor === undefined ? 0 : b.total_debtor
                ),
              0
            )
          )}
        </CardStatics>
      </div>
      <div style={{ display: 'flex' }}>
        <GlobalFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          disableButtomCreate={true}
        />
        <SelectWihoutControl
          label={''}
          size={3}
          data={TYPE_FILTER}
          onChange={handleChangeDataReport}
          value={reportFilter}
        />
      </div>

      <Table responsive striped hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  scope='col'
                  {...column.getHeaderProps()}
                  style={{ fontSize: '18px' }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr key={i} {...row.getRowProps()}>
                  {row.cells.map((cell, i) => {
                    return (
                      <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '18px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Nenhum registro para mostrar!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export const ReportList = () => {
  const [rawData, setRawData] = useState([]);
  const [report, setReport] = useState([]);
  const [reportFilter, setReportFilter] = useState('Todos');

  useEffect(() => {
    async function getAllDebtorByClient() {
      const data = await handleSendGeneric(`/v1/client/debtors`, 'GET');
      const sortedData = _.orderBy(data, ['lastUpdate'], ['desc']);

      if (sortedData !== undefined) {
        setReport(sortedData.filter((rp) => parseFloat(rp.total_debtor) > 0));
        setRawData(sortedData.filter((rp) => parseFloat(rp.total_debtor) > 0));
      }
    }

    getAllDebtorByClient();
  }, []);

  const cacheItemsDisabled = React.useMemo(() => report, [report]);

  const columns = useMemo(
    () => [
      {
        Header: 'Última Visita',
        accessor: 'lastVisited',
      },
      {
        Header: 'Razão Social',
        accessor: 'client.name',
      },
      {
        Header: 'Cidade',
        accessor: 'client.city',
      },
      {
        Header: 'Devedor',
        Cell: ({ ...props }) => {
          const total_debtor = props.data[props.row.index]?.total_debtor;
          return <span>{convertBrl(total_debtor)}</span>;
        },
      },
    ],
    []
  );

  return (
    <>
      <Header />
      <Container className='mt--7' fluid>
        <Row>
          <div className='col'>
            <Card className='shadow'>
              <TableGeneric
                columns={columns}
                data={cacheItemsDisabled}
                reportFilter={reportFilter}
                setReportFilter={setReportFilter}
                reportData={report}
                setReportData={setReport}
                rawData={rawData}
              />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
